import { render, staticRenderFns } from "./EnquiryCard.vue?vue&type=template&id=6dd433d2&lang=pug&"
import script from "./EnquiryCard.vue?vue&type=script&lang=js&"
export * from "./EnquiryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports